/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useState } from 'react';
import { Divider, IconButton, List, Text } from 'react-native-paper';
import { useSelector } from 'react-redux';
import { FlatList, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import Modal from 'react-native-modal';
import { modalConatiner, modalHeader, theme } from '../theme/theme';

const CountersModal = ({ visible, onCounterModalClose, onCounterSelect }) => {
    const canteens = useSelector(state => state.cafe.canteens);
    const [isModalVisisble, setModalVisible] = useState(visible);

    useEffect(() => {
        setModalVisible(visible);
    }, [visible]);

    const closeCounterModal = () => {
        setModalVisible(false);
        if (onCounterModalClose) {
            onCounterModalClose(false);
        }
    };

    const onCounterClick = ({ item, index }) => {
        if (onCounterSelect) {
            onCounterSelect(item);
        }
    };

    const renderItem = ({ item, index }) => <List.Item onPress={() => onCounterClick({ item, index })} title={item?.canteen_name} titleStyle={{ fontSize: 14 }} />;

    return (
        <Modal
            animationOutTiming={300}
            coverScreen={true}
            backdropTransitionOutTiming={300}
            hideModalContentWhileAnimating={true}
            isVisible={isModalVisisble}
            onBackButtonPress={closeCounterModal}
            onBackdropPress={closeCounterModal}
            style={modalConatiner}>
            <SafeAreaView style={styles.modalView}>
                <View style={[modalHeader, { backgroundColor: theme.colors.primary }]}>
                    <Text variant="titleMedium" style={{ color: theme.colors.onPrimary }}>Counters</Text>
                    <IconButton icon="close"
                        onPress={closeCounterModal}
                        iconColor={theme.colors.onPrimary}
                        size={20} />
                </View>
                <Divider />
                <FlatList
                    data={canteens}
                    renderItem={renderItem}
                    keyExtractor={(item, index) => (item?.canteen_id).toString()}
                // ListFooterComponent={<Divider />}
                />
            </SafeAreaView>
        </Modal>
    );
};

const styles = StyleSheet.create({
    modalView: {
        // flexGrow: 1,
        minHeight: '20%',
        backgroundColor: '#ffffff',
        borderRadius: 16,
        margin: 6,
    },
});

export default CountersModal;

